import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { externalLinkClicked } from './tourTracking';
import { getStepId } from './tourTransformer';
/**
 * Given a tour, this function will populate that tour with copy given that the copy is formatted correctly.
 * @param {tourConfig} tour
 */

export const populateTourWithCopy = tour => {
  const {
    i18nPrefix
  } = tour;

  if (tour.recommendNextTour) {
    tour.recommendNextTour.title = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.title`);
    tour.recommendNextTour.text = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.text`);
    tour.recommendNextTour.cta = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.cta`);
  }

  tour.steps.forEach((step, stepIndex) => {
    const stepNumber = stepIndex + 1;

    if (step.text === true || typeof step.text === 'object') {
      step.text = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `onboarding-tours-${i18nPrefix}.step${stepNumber}.text`
      });
    }

    if (step.externalStepLink) {
      step.externalStepComponent = /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: step.externalStepLink,
        onClick: () => externalLinkClicked(getStepId(stepIndex), tour.alias),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `onboarding-tours-${i18nPrefix}.step${stepNumber}.externalStepLink`
        })
      });
    }

    if (step.title === true) {
      step.title = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.title`);
    }

    if (step.actionText === true) {
      step.actionText = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.actionText`);
    }

    if (typeof step.showMeHowClickHandler === 'function') {
      step.showMeHowText = /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: props => /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
            onClick: step.showMeHowClickHandler
          }))
        },
        message: `onboarding-tours-${i18nPrefix}.step${stepNumber}.showMeHow_jsx`
      });
    }

    if (step.buttons) {
      step.buttons.forEach((button, buttonIndex) => {
        const buttonNumber = buttonIndex + 1;

        if (button.text === true) {
          button.text = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.button${buttonNumber}`);
        } else if (typeof button.commonText === 'string') {
          button.text = I18n.text(`onboarding-tours-common.button.${button.commonText}`);
        }
      });
    }
  });
  return tour;
};